import { ThemeProvider as MuiProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"

export const theme = createTheme({
  palette: {
    secondary: {
      main: "#30673C",
    },
    common: {
      black: "#171717",
    },
    info: {
      main: "#1FA009",
    },
    grey: {
      200: "#EDEDED",
      400: "#999999",
    },
  },
})

const ThemeProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  return (
    <MuiProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiProvider>
  )
}

export default ThemeProvider
